import axios from "axios";
import { queryString } from "object-query-string";
import {
  SET_ALL_REPORTS,
  SET_NEW_REPORT,
  SET_REPORT_SEARCH,
  DELETE_REPORT,
} from "../actions/types";
import { displayNotification } from "./notificationActions";
import { toggleDisableButton } from "./configActions";

import { Clipboard } from "react-feather";

export const setReports =
  (domainId, pageNum = 1, search, limit = 15) =>
  (dispatch) => {
    let baseSearchPath = `reports/${domainId}?pageNum=${pageNum}&limit=${limit}`;
    if (search) {
      const query = queryString(search);
      baseSearchPath = `${baseSearchPath}&${query}`;
    }
    axios
      .get(baseSearchPath)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: SET_ALL_REPORTS,
          payload: data,
        });
      })
      .catch((error) => {});
  };

export const searchReports = (domainId, pageNum, search) => (dispatch) => {
  dispatch({
    type: SET_REPORT_SEARCH,
    payload: search,
  });
  dispatch(setReports(domainId, pageNum, search));
};

export const createReport =
  (domain, search, startDate, endDate, format, type, clearFormAndModal) => (dispatch) => {
    dispatch(toggleDisableButton(true));
    const query = queryString(search);
    axios({
      url: `reports/${domain._id}`,
      data: {
        startDate: startDate,
        endDate: endDate,
        query,
        format,
        type
      },
      method: "POST",
    })
      .then((response) => {
        dispatch({
          type: SET_NEW_REPORT,
          payload: response.data.report,
        });
        dispatch(toggleDisableButton(false));
        dispatch(
          displayNotification({
            type: "success",
            message:
              "Your report will be in reports section in couple of minutes.",
            customIcon: <Clipboard size={20} className="mr-2" color="green" />,
          })
        );
        clearFormAndModal();
      })
      .catch((error) => {
        dispatch(toggleDisableButton(false));
        dispatch(
          displayNotification({
            type: "error",
            message:
              "Not able to perform this action, please contact support team.",
          })
        );
      });
  };

export const removeReport = (domainId, reportId) => (dispatch) => {
  dispatch(toggleDisableButton(true));
  axios
    .delete(`reports/${domainId}/${reportId}`)
    .then((response) => {
      dispatch(toggleDisableButton(false));
      dispatch({
        type: DELETE_REPORT,
        payload: reportId,
      });
      dispatch(
        displayNotification({
          type: "success",
          message: "Report successfully deleted.",
        })
      );
    })
    .catch((error) => {
      dispatch(toggleDisableButton(false));
      dispatch(
        displayNotification({
          type: "error",
          message: "Not able to delete report.",
        })
      );
    });
};
